export default class ForgotPasswordRequest {
    constructor(email = '') {
        this.email = email
    }
}